import React, { useMemo } from "react";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import dayjs from "dayjs";

const FuelChargeHistoryTable = ({ rows }) => {
  const columns = useMemo(
    () => [
      {
        id: "EffectiveDate",
        header: "Effective Date",
        sortingFn: "datetime",
        accessorFn: (row) => (row.EffectiveDate ? new Date(row.EffectiveDate) : null),
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? dayjs(value).format("MM/DD/YYYY") : "";
        },
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
      {
        accessorKey: "InjectionValue",
        header: "Injection",
        Cell: ({ cell }) => cell.getValue() ?? "",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
      {
        accessorKey: "WithdrawalValue",
        header: "Withdrawal",
        Cell: ({ cell }) => cell.getValue() ?? "",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data: rows ?? [],
    enableSorting: true,
    enablePagination: true,
    enableColumnFilters: false,
    enableFullScreenToggle: false,
    enableColumnActions: false,
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableTopToolbar: false,
    enableRowActions: false,
    enableRowSelection: false,
    enableHiding: false,
    initialState: {
      sorting: [{ id: "EffectiveDate", desc: true }],
      pagination: { pageSize: 10, pageIndex: 0 },
    },
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#1a3a5c",
        color: "#fff",
        fontWeight: 700,
        textAlign: "center",
        borderRight: "1px solid rgba(255,255,255,0.12)",
        py: 1.5,
        "& .Mui-TableHeadCell-Content": {
          justifyContent: "center",
        },
        "& .MuiTableSortLabel-icon": {
          color: "#fff !important",
        },
      },
    },
    muiTableBodyCellProps: {
      sx: {
        borderRight: "1px solid #e0e7ef",
        py: 0.75,
        px: 1,
        "&:last-child": { borderRight: "none" },
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        border: "1px solid #e0e7ef",
        borderRadius: "10px",
        overflow: "hidden",
        mt: 2,
      },
    },
  });

  return (
    <Grid container direction="row" spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Typography variant="h2" className="userprofilelistcontent">
          FUEL CHARGE HISTORY
        </Typography>
        <MaterialReactTable table={table} />
      </Grid>
    </Grid>
  );
};

export default FuelChargeHistoryTable;
